import { pausedCopyFor } from "./paused-copy";

/**
 * The clinic-facing notice for a turn the assistant stopped on purpose
 * (SCRUM-300). Keyed by the harness spec section 15 reason code the runtime
 * emits on the `data-paused` stream part, never by parsing the prose.
 */
export function PausedNotice({ reasonCode }: { reasonCode: string }) {
  const copy = pausedCopyFor(reasonCode);

  return (
    <div
      role="status"
      data-testid="copilot-paused-notice"
      data-reason-code={reasonCode}
      // The project's own tokens, not raw Tailwind colours: the design-tokens
      // ratchet in `src/lib/design-tokens.test.ts` refuses a file that adds
      // hard-coded colour, and it caught the first draft's `amber-*`.
      className="rounded-lg border border-app-warning bg-app-surface-muted p-3 text-sm text-app-fg"
    >
      <p className="font-medium text-app-fg-strong">{copy.title}</p>
      <p className="mt-1 text-app-fg-muted">{copy.body}</p>
    </div>
  );
}
